import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

function PrivacyPolicy() {
  return (
    <>
      <Helmet>
        <title>WebsiteSEO</title>
        <meta name="description" content={"Website SEO"} />
        <meta name="keywords" content={"Website SEO  "} />
        <link rel="canonical" href={"https://www.websiteseo.ae/Privacy-Policy"} />
        <script type="application/ld+json">
          {JSON.stringify({
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Websiteseo",
  "url": "https://www.websiteseo.ae/",
  "logo": {
    "@type": "ImageObject",
    "url": "https://www.websiteseo.ae/images/img/logo.png"
  },
  "description": "WebsiteSEO is a digital solutions agency offering website design and development, SEO, mobile app development, domain registration, web hosting, social media marketing, email marketing, SMS marketing, branding, and online marketing services to help businesses build and strengthen their digital presence.",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Office# 114 Al Ahbabi Building Damascus Street, Al Qusais Dubai, United Arab Emirates",
    "addressLocality": "Dubai",
    "addressRegion": "Dubai",
    "postalCode": "00000",
    "addressCountry": "UAE"
  },
  "contactPoint": [
    {
      "@type": "ContactPoint",
      "telephone": "+971 55 570 9788",
      "contactType": "customer service",
      "email": "sales@websiteseo.ae"
    }
  ]
})}
        </script>
      </Helmet>

<div>
  {/* HEADER
  ============================================= */}
  {/* END HEADER */}
  {/* HERO
  ============================================= */}
  <div className="inner-page-banner-wrap" style={{backgroundImage: 'url(/legacy/images/img/inner-banner-bg.jpg)', backgroundSize: 'cover', backgroundAttachment: 'fixed'}}>
    <div className="container">
      <h3>Privacy Policy</h3>
      <ul>
        <li><Link to="/">Home</Link></li>
        <li>Privacy Policy</li>
      </ul>
    </div>
  </div>
  {/* CONTACTS
              ============================================= */}
  {/* TEXT CONTENT
  ============================================= */}
  <section className=" ct-01 content-section division py-100">
    <div className="container">
      <h5 className="fs-20 mb-2 ">Privacy Policy</h5>
      <p>
        We are fully committed to protect your privacy. Whenever any private information is asked from our side, you can get rest assured that it will be used as per the terms of this privacy policy only. We always hold the personal information of the client in the highest regard. WebsiteSEO.ae fully abides by the privacy laws of the United Arab Emirates. It is important for our clients and visitors to understand how we collect and utilize the information that is provided to us. Later, this helps our clients in making informed decisions. We continuously review our policies with the advent of newer technologies, business trends and as per client’s needs.
      </p>
      <h5 className="fs-20 mb-2 ">Use of personal information</h5>
      <p>
        WebsiteSEO.ae makes use of personal information provided by clients only to contact them, discuss about project’s, detail and progress. Our team only communicates with clients. We do not sell or share any personal information with third parties for any marketing purpose. We never store the credit card details of the customers nor share the same with any third party. WebsiteSEO.ae abides by all laws and protects the right of clients to prevent any fraud. We also make use of advanced security systems to protect the personal data of clients and visitors from any misuse or loss. Occasionally, we may utilize the information to notify the client about any major changes, special services, offers that they might find interesting.
      </p>
      <h5 className="fs-20 mb-2 ">Amending this policy</h5>
      <p>
        It is our right to amend this policy as and when required. Any changes in our privacy policy is notified to the clients. We regularly advise our clients to review this page and keep abreast of any recent changes. Please be assured that even if privacy policy is amended in future, your personal information will not be compromised that you have shared with us.
      </p>
    </div>	   {/* End container */}
  </section>	{/* END TEXT CONTENT */}
  {/* FOOTER
  ============================================= */}
  {/* END FOOTER */}
</div>

    </>
  );
}

export default PrivacyPolicy;
